import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M270-270h140q17 0 28 12t12 28q0 17-12 28-11 12-28 12H230q-17 0-28-12t-12-28v-180q0-17 12-28t28-12q17 0 28 12 12 11 12 28v140Zm420-420H550q-17 0-28-12t-12-28q0-17 12-28 11-12 28-12h180q17 0 28 12t12 28v180q0 17-12 28t-28 12q-17 0-28-12-12-11-12-28v-140Z"/>',
  f: '<path d="M270-270h140q17 0 28 12t12 28q0 17-12 28-11 12-28 12H230q-17 0-28-12t-12-28v-180q0-17 12-28t28-12q17 0 28 12 12 11 12 28v140Zm420-420H550q-17 0-28-12t-12-28q0-17 12-28 11-12 28-12h180q17 0 28 12t12 28v180q0 17-12 28t-28 12q-17 0-28-12-12-11-12-28v-140Z"/>',
};

export default data;
